import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiPhone, FiLinkedin, FiAward, FiUsers, FiTrendingUp } = FiIcons;

const Team = () => {
  const leadership = [
    {
      name: 'Jasmin Hubler',
      position: 'Geschäftsführung',
      image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      bio: 'Mit Weitblick und Engagement führt Jasmin Hubler das Unternehmen. Ihre Vision: Facility Services auf einem neuen Level – wo andere aufhören, fangen wir an.',
      email: 'info@hublertex.ch',
      phone: '+41 76 625 07 64',
      linkedin: '#',
      specialties: ['Unternehmensführung', 'Strategische Entwicklung', 'Qualitätsmanagement']
    }
  ];

  const stats = [
    { number: '45+', label: 'Mitarbeiter', icon: FiUsers },
    { number: '15+', label: 'Jahre Erfahrung', icon: FiAward },
    { number: '98%', label: 'Mitarbeiterzufriedenheit', icon: FiTrendingUp }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-orange-500 to-orange-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-5xl font-bold mb-6">Unser Team</motion.h1>
          <p className="text-xl max-w-3xl mx-auto">Die Köpfe hinter Hubler & Tex Facility Services.</p>
        </div>
      </section>

      {/* Leadership */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {leadership.map((leader, index) => (
              <motion.div key={index} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} className="bg-gray-50 rounded-2xl shadow-xl overflow-hidden md:flex relative">
                <div className="md:w-1/3 relative">
                  <img src={leader.image} alt={leader.name} className="w-full h-full object-cover min-h-[300px]" />
                </div>
                <div className="md:w-2/3 p-8 lg:p-12 relative">
                  <div className="absolute top-4 right-4 sm:top-8 sm:right-8">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-200 text-slate-800 border border-slate-300 shadow-sm">
                        Demo-Daten
                    </span>
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-2">{leader.name}</h2>
                  <p className="text-orange-500 font-semibold text-xl mb-6">{leader.position}</p>
                  <p className="text-gray-600 text-lg mb-8 leading-relaxed">{leader.bio}</p>
                  <div className="space-y-4 mb-8">
                    <div className="flex items-center space-x-3 text-gray-600">
                      <SafeIcon icon={FiMail} className="text-orange-500 w-5 h-5" />
                      <span>{leader.email}</span>
                    </div>
                    <div className="flex items-center space-x-3 text-gray-600">
                      <SafeIcon icon={FiPhone} className="text-orange-500 w-5 h-5" />
                      <span>{leader.phone}</span>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {leader.specialties.map((s, i) => (
                      <span key={i} className="bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-sm font-medium">{s}</span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            {stats.map((stat, idx) => (
              <div key={idx} className="p-8 bg-white rounded-xl shadow-sm relative">
                <span className="absolute top-3 right-3 inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-slate-100 text-slate-600 border border-slate-200">
                    Demo-Daten
                </span>
                <SafeIcon icon={stat.icon} className="w-12 h-12 text-orange-500 mx-auto mb-4" />
                <div className="text-4xl font-bold text-gray-900 mb-2">{stat.number}</div>
                <div className="text-gray-600 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-orange-500 text-white text-center">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold mb-6">Werden Sie Teil unseres Teams</h2>
          <p className="text-xl mb-8 opacity-90">Wir suchen immer engagierte Fachkräfte für Wynau und Umgebung.</p>
          <a href="mailto:info@hublertex.ch" className="bg-white text-orange-500 px-10 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors">Jetzt bewerben</a>
        </div>
      </section>
    </div>
  );
};

export default Team;